export class NavBarItem {
  id: string;
  name: string;
  badge?: string;
  link: any;
}
